<script setup lang="ts">
import { ref } from "vue";
import { Training } from "@/types/training/Training";
import { useModal } from "@/utils/modal";
import { onMounted } from "vue";
import { onUnmounted } from "vue";
import { computed } from "vue";
import router from "@/router";
import Question from "./organisms/Question.vue";

const modal = useModal();

const training = ref<Training | null>(null);
const transitionDisabled = computed(() => {
  return router.currentRoute.value.query.transition === "false";
});

onMounted(() => {
  registerEvents();
  fireInitEvent();
});

onUnmounted(() => {
  unregisterEvents();
});

function registerEvents() {
  window.addEventListener("message", onMessage);
}

function unregisterEvents() {
  window.removeEventListener("message", onMessage);
}

function fireInitEvent() {
  // トレーニングプレビューが準備完了したことを通知
  if (!window.opener) return;
  window.opener.postMessage({ type: "trainingPreviewReady" }, "*");
}

function onMessage(event: MessageEvent) {
  if (event.data.type !== "training") return;

  training.value = event.data.value;
}

async function onTrainingFinished() {
  await modal.msgBoxOk("これで終了です。お仕事頑張ってください！", {
    centered: true
  });
}
</script>

<template>
  <div v-if="training">
    <Question
      :training="training"
      @finish="onTrainingFinished"
      :transition-disabled="transitionDisabled"
    />
  </div>
</template>

<style lang="scss" scoped></style>
